var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import Icon from '../../../Icon';
const IconInfo = (_a) => {
    var { size, fill } = _a, commonProps = __rest(_a, ["size", "fill"]);
    const iconContent = {
        type: 'svg',
        content: (React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("path", { d: "M12.75 16.5C12.75 16.914 12.414 17.25 12 17.25C11.586 17.25 11.25 16.914 11.25 16.5V11.25C11.25 10.836 11.586 10.5 12 10.5C12.414 10.5 12.75 10.836 12.75 11.25V16.5Z", fill: "black" }),
            React.createElement("path", { d: "M12 7.40625C12.4657 7.40625 12.8438 7.78425 12.8438 8.25C12.8438 8.71575 12.4657 9.09375 12 9.09375C11.5343 9.09375 11.1562 8.71575 11.1562 8.25C11.1562 7.78425 11.5343 7.40625 12 7.40625Z", fill: "black" }),
            React.createElement("path", { d: "M12 21.75C17.3842 21.75 21.75 17.3842 21.75 12C21.75 6.61575 17.3842 2.25 12 2.25C6.61575 2.25 2.25 6.61575 2.25 12C2.25 17.3842 6.61575 21.75 12 21.75ZM12 3.75C16.5562 3.75 20.25 7.44375 20.25 12C20.25 16.5562 16.5562 20.25 12 20.25C7.44375 20.25 3.75 16.5562 3.75 12C3.75 7.44375 7.44375 3.75 12 3.75Z", fill: "black" }))),
        alt: 'Icon Info',
    };
    return React.createElement(Icon, Object.assign({}, commonProps, { source: iconContent, size: size, fill: fill }));
};
export default IconInfo;
//# sourceMappingURL=index.js.map